import { pick, omit } from 'lodash';
export default function intlNumberFormat(n, options) {
    if (isNaN(Number(n)))
        console.warn('Not a number');
    const adjustedOptions = Object.assign({}, (options || {}));
    // why this is needed: because of possible conflict between minimumFractionDigits and maximumFractionDigits. even if we don't set minimumFractionDigits, they can be set automatically for type currency
    if (adjustedOptions.maximumFractionDigits && adjustedOptions.minimumFractionDigits && adjustedOptions.minimumFractionDigits > adjustedOptions.maximumFractionDigits) {
        adjustedOptions.minimumFractionDigits = adjustedOptions.maximumFractionDigits;
    }
    // why 2-step formatting is needed is because of seemingly strange override (set in ECMA spec though) of fraction digits min max by significant digits min max
    // https://stackoverflow.com/a/55836153/6565721
    const a = Number(new Intl.NumberFormat('en-US', pick(adjustedOptions, ['maximumSignificantDigits', 'minimumSignificantDigits'])).format(n).replace(/,/g, ''));
    if (isNaN(a))
        console.warn('Not a number');
    const b = new Intl.NumberFormat(undefined, omit(adjustedOptions, ['maximumSignificantDigits', 'minimumSignificantDigits'])).format(a);
    return b;
}
